import { apiClient } from "./api";
const baseService = {
    getAll: async (filters) => {
        const params = new URLSearchParams();
        if (filters?.status)
            params.append("status", filters.status);
        if (filters?.region)
            params.append("region", filters.region);
        const queryString = params.toString();
        const response = await apiClient.get(`/bases/${queryString ? `?${queryString}` : ""}`);
        return response.data;
    },
    getById: async (baseId) => {
        const response = await apiClient.get(`/bases/${baseId}/`);
        return response.data;
    },
    create: async (data) => {
        const response = await apiClient.post("/bases/", data);
        return response.data;
    },
    update: async (baseId, data) => {
        const response = await apiClient.put(`/bases/${baseId}/`, data);
        return response.data;
    },
    delete: async (baseId) => {
        await apiClient.delete(`/bases/${baseId}/`);
    },
    getDrones: async (baseId) => {
        const response = await apiClient.get(`/bases/${baseId}/drones/`);
        return response.data;
    },
    addDrone: async (baseId, droneId) => {
        const response = await apiClient.post(`/bases/${baseId}/drones/`, {
            drone_id: droneId,
        });
        return response.data;
    },
    getStats: async () => {
        const response = await apiClient.get("/bases/stats/");
        return response.data;
    },
    findNearest: async (lat, lng) => {
        const response = await apiClient.get(`/bases/nearest/?lat=${lat}&lng=${lng}`);
        return response.data;
    },
};
export default baseService;
